import React from 'react';

export interface SettingsPanelProps {
    title: string
    children: any
}

export const SettingsPanel = (props: SettingsPanelProps) => {
    const { title, children } = props

    return <div className='settings' style={{zIndex: 100}}>
        <h4 className='settingsHeader'>{title}</h4>
        <div>
            {children}
        </div>
    </div>
}